import { Header } from "@albelli/arc-3-react/lib/Header";
import { Loader } from "@albelli/arc-3-react/lib/Loader/Loader";
import { requestSignOut } from "application/auth/authActions";
import { requestMenu } from "application/menu/menuActions";
import { isLoading } from "helpers/requestStateHelper";
import { isNotRequested } from "helpers/requestStateHelper.js";
import { vendor } from "helpers/vendorHelper";
import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

export const MyAccountHeader = ({ isAuthenticated }) => {
  const menu = useSelector(state => state.menu);
  const mainUrl = useSelector(state => state.menu.items.routes.Main);
  const history = useHistory();

  const dispatch = useDispatch();
  useEffect(() => {
    if (isNotRequested(menu)) {
      dispatch(requestMenu());
    }
  }, []);

  const { items } = menu;

  if (isLoading(menu) || !items || !items.menus) return <Loader />;

  return (
    <Header
      topBar={items.menus.top}
      mainUrl={mainUrl}
      menu={items.menus.main}
      isAuthenticated={isAuthenticated}
      onLogout={() => dispatch(requestSignOut())}
      onLocalNavigation={route => history.push(route)}
      localizedMenuName={<FormattedMessage id="menu.menu" defaultMessage="MENU" />}
      vendor={vendor}
    />
  );
};
